import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { cardSettingsScreens } from '../constants';
import MainBodyLayout from '../partials/MainBodyLayout';
import { CardSettingsContext } from '../../../../contexts/card/settings/context';
import { dynamicAssets } from '../../../../utilities/helpers';

const ErrorTx = () => {
  const { t: translate } = useTranslation();
  const { openScreen } = useContext(CardSettingsContext);

  return (
    <MainBodyLayout
      withBack
      onPrevClick={() => openScreen(cardSettingsScreens.CONFIRM_EXPEDITED_AMOUNT)}
      title={translate('error')}>
      <img
        style={{
          width: '100%',
          height: '40%',
          marginTop: '6rem',
          resize: 'contain',
          alignSelf: 'center',
        }}
        src={dynamicAssets('./assets/images/error.svg')}
        alt="warning"
      />
      <div className="text-f5 mt-5">
        <p className="text-center">{translate('not_enough_card_balance')}</p>
      </div>
      <div
        className={`d-flex flex-row mt-5 pt-3 ${
          isMobile ? 'position-fixed w-95 bg-light pb-3 pe-2' : 'mx-2 px-5'
        }`}
        style={{ bottom: '0', left: '0', zIndex: 100 }}>
        <button
          onClick={() => {
            openScreen(cardSettingsScreens.CONFIRM_DELIVERY_TYPE);
          }}
          type="button"
          className="btn py-3 btn-primary w-100">
          {translate('proceed_standard')}
        </button>
      </div>
    </MainBodyLayout>
  );
};

export default ErrorTx;
